import React, { useState, useEffect, lazy } from 'react';
import ReactDOM from 'react-dom';
import { useAuth } from '../../auth/Auth';
import { feedViewModel } from './feed.view.model';
import CampHeader from '../../header/CampHeader';
import CampHeaderGuest from '../../header/CampHeaderGuest';
import InfiniteScroll from 'react-infinite-scroller';
import FeedGallery from './FeedGallery';
import { useCreationHolder } from '../../context/creation/creation.holder.context';
import { actionTypes } from '../../context/creation/creation.reducer';
import './scss/home.feed.scss';
const LeftSideBar = lazy(() => import('../../common/LeftSideBar'));
const RightSideBar = lazy(() => import('../../common/RightSideBar'));
const GetVerifiedNowModal = lazy(() =>
  import('../next_challenge/getVerifiedNowModal')
);
const OfTheDay = lazy(() => import('./OfTheDay'));
import TaletreeLoader from '../taletree_loader/TaletreeLoader';
import OptimizeSignup from '../onboarding/signup_popups/OptimizeSignup';
import HomeFeedFilter from './HomeFeedFilter';
import ConnectCampModal from '../../common/ConnectCampModal';
import { MULTI_LOGIN } from '../../../constants/routes.constants';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const HomeFeed = () => {
  const history = useHistory();
  const isGuardianFromBrowse = localStorage.getItem('isGuardianFromBrowse');
  const _PAGE_LIMIT = 10;
  const { dependent, guardian, fetchAPI, partner, school } = useAuth();
  const [feedList, setFeedList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [rightCollapsse, setRightCollapsse] = useState('');
  const [leftCollapsse, setLeftCollapsse] = useState('');
  const [showGetVerifiedModal, setShowGetVerifiedModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('latest');
  const [showCampModal, setShowCampModal] = useState(false);
  const [query, setQuery] = useState({
    limit: _PAGE_LIMIT,
    has_more: true,
    trending: false,
  });
  const { creationHolder, dispatchCreationHolder } = useCreationHolder();

  useEffect(() => {
    if (dependent || guardian || partner || school) {
      setShowModal(false);
    } else {
      setShowModal(true);
    }
  }, []);

  const getFeed = () => {
    setIsLoading(true);
    const previousFeedList = feedList;
    fetchAPI(feedViewModel.getFeed, query, previousFeedList)
      .then((data) => {
        ReactDOM.unstable_batchedUpdates(() => {
          setFeedList(data.feedList);
          setQuery(data.query);
        });
        setIsLoading(false);
      })
      .catch((error) => {
        // addError(error.data.message)
      });
  };

  const getInfiniteFeed = () => {
    if (!isLoading) getFeed();
  };

  useEffect(() => {
    if (!isLoading) getFeed();
  }, [selectedFilter]);

  const handleBinky = (creationId, binkyId, binkyCount) => {
    if (!dependent.profile.is_activated) {
      return setShowGetVerifiedModal(true);
    }
    // update feed list
    const newFeedList = feedList.map((obj) => {
      if (obj.creation_id === creationId)
        return {
          ...obj,
          binky_count: binkyCount,
          binky_id: binkyId,
        };
      return obj;
    });
    setFeedList(newFeedList);
    // update creationHolder's creation list
    if (creationHolder.user.creationList === null) return;
    const newList = creationHolder.user.creationList.map((obj) => {
      return obj.id === creationId
        ? {
          ...obj,
          binky_count: binkyCount,
          binky_id: binkyId,
        }
        : obj;
    });
    dispatchCreationHolder({
      type: actionTypes.UPDATE_USER_CREATIONS,
      payload: {
        ...creationHolder.user,
        creationList: newList,
      },
    });
  };

  const handleComment = (creationId, commentCount) => {
    if (!dependent.profile.is_activated) {
      return setShowGetVerifiedModal(true);
    }
    // update feed list
    const newFeedList = feedList.map((obj) => {
      if (obj.creation_id === creationId)
        return {
          ...obj,
          comment_count: commentCount,
        };
      return obj;
    });
    setFeedList(newFeedList);
    // update creationHolder's creation list
    if (creationHolder.user.creationList === null) return;
    const newList = creationHolder.user.creationList.map((obj) => {
      return obj.id === creationId
        ? {
          ...obj,
          comment_count: commentCount,
        }
        : obj;
    });
    dispatchCreationHolder({
      type: actionTypes.UPDATE_USER_CREATIONS,
      payload: {
        ...creationHolder.user,
        creationList: newList,
      },
    });
  };

  const handleScroll = () => {
    document.body.classList.toggle('noscroll');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    localStorage.removeItem('partner');
  }, []);

  const onMyCampClick = (filter) => {
    if (!dependent && !guardian) {
      if (!dependent && !guardian && !school) {
        setShowModal(true);
      }
      return;
    }
    if (dependent && !dependent?.profile?.group?.id) {
      return setShowCampModal(true);
    }
    setFeedList(null);
    setQuery((prevStat) => {
      const p = {
        ...prevStat,
        starting_after: 0,
        trending: false,
        has_more: true,
        group_id: dependent?.profile?.group?.id,
        camp_id: dependent?.school_details?.id,
      };
      delete p.title;
      delete p.starting_after;
      return p;
    });
    setSelectedFilter(filter);
  };
  const location = useLocation();
  const path = location;
 
  const handleRedirecBrows = () => {
    if (isGuardianFromBrowse === 'false' && path?.pathname === '/' &&  !guardian) {
      console.log("inside")
      // history.push(MULTI_LOGIN);
    }else  if ( !isGuardianFromBrowse && path?.pathname === '/' && guardian) {
      history.push(MULTI_LOGIN);
    }
  };

  useEffect(() => {
    handleRedirecBrows();
  }, []);
  return (
    <div>
      {dependent && !guardian ? (
        <CampHeader leftCollapsse={leftCollapsse} rightCollapsse={rightCollapsse} />
      ) : (
        <CampHeaderGuest leftCollapsse={leftCollapsse} rightCollapsse={rightCollapsse} />
      )}
      <div className="home-feed-container home-feed-wrapper">
        <div className="flex-wrapper">
          <LeftSideBar rightCollapsse={rightCollapsse} myInterests={true} setLeftCollapsse={setLeftCollapsse} setShowModal={setShowModal} />
          <div className={'flex-col-center mt-2 challenge-list-container' + ' ' + rightCollapsse + ' ' + leftCollapsse}  >
            <OfTheDay />
            <HomeFeedFilter selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} setFeedList={setFeedList} setQuery={setQuery} onMyCampClick={onMyCampClick} getFeed={getFeed} />
            <InfiniteScroll pageStart={0} loadMore={getInfiniteFeed} hasMore={query.has_more} threshold={150} className="home-feed-spinner-wrapper" loader={<TaletreeLoader />} >
              <FeedGallery   {...{ feedList, handleBinky, handleScroll, handleComment, isLoading, }} />
            </InfiniteScroll>
            {showGetVerifiedModal ? (<GetVerifiedNowModal show={showGetVerifiedModal} setShow={setShowGetVerifiedModal} />
            ) : ('')}
          </div>
          <RightSideBar leftCollapsse={leftCollapsse} setRightCollapsse={setRightCollapsse} isNewChallengesButton={true} />
          <OptimizeSignup showModal={showModal} setShowModal={setShowModal} />
          {showCampModal && (<ConnectCampModal showModal={showCampModal} setShowModal={setShowCampModal} />)}
        </div>
      </div>
    </div>
  );
};

export default HomeFeed;